import { render, staticRenderFns } from "./AddDocumentFile.vue?vue&type=template&id=8eb231c0&"
import script from "./AddDocumentFile.vue?vue&type=script&lang=js&"
export * from "./AddDocumentFile.vue?vue&type=script&lang=js&"
import style0 from "./AddDocumentFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports